import { useMediaContext } from '../../../features/Media/providers/MediaContextProvider';
import { useMeetContext } from '../../../features/Meet/providers/MeetContextProvider';
import { useTranslationsContext } from '../../../features/Translations/providers/TranslationsContextProvider';
import InfoIcon from '../../assets/icons/info.svg?react';
import NoVideoIcon from '../../assets/icons/vc-no-video.svg?react';
import { NamedAvatar } from '../NamedAvatar/NamedAvatar';
import {
	Video,
	VideoPreviewCamDisabled,
	VideoPreviewContainer,
	VideoPreviewPlaceholder,
	VideoPreviewPlaceholderInfo,
	VideoPreviewPlaceholderInfoIcon,
} from './style';

export interface VideoPreviewProps {
	$showVideo?: boolean;
	$mirror?: boolean;
	grantedPermissions?: boolean;
}

export function VideoPreview({
	$showVideo = false,
	$mirror = false,
	grantedPermissions = false,
}: VideoPreviewProps) {
	const { isProfessional, professionalData, patientData } = useMeetContext();
	const { checkedMediaPermissions } = useMediaContext();
	const { t } = useTranslationsContext();

	return (
		<VideoPreviewContainer>
			<Video id="video-preview" className="video-preview" hidden={!$showVideo} $mirror={$mirror} />
			{grantedPermissions && !$showVideo && (
				<>
					<VideoPreviewCamDisabled>
						<NamedAvatar
							name={isProfessional ? professionalData?.fullName : patientData?.fullName}
							size={92}
						/>
					</VideoPreviewCamDisabled>
				</>
			)}
			{!grantedPermissions && checkedMediaPermissions && (
				<>
					<VideoPreviewPlaceholder>
						<NoVideoIcon fill={'#222222'} width={74} height={66} />
					</VideoPreviewPlaceholder>
					<VideoPreviewPlaceholderInfo>
						<VideoPreviewPlaceholderInfoIcon>
							<InfoIcon />
						</VideoPreviewPlaceholderInfoIcon>
						{t('config.mic_and_vid_not_granted')}
					</VideoPreviewPlaceholderInfo>
				</>
			)}
		</VideoPreviewContainer>
	);
}
